import { useState, useEffect } from "react";
import { api } from "../../context";

export default function Chats({ t }) {
  const [data, setData] = useState(null);
  const [conversations, setConversations] = useState([]);
  const [redRooms, setRedRooms] = useState([]);
  const [loading, setLoading] = useState(true);

  const CARD=t.card,BORDER=t.border,TEXT=t.text,SUB=t.sub,PRI=t.pri,GRN=t.grn,RED=t.red,GOLD=t.gold;

  useEffect(() => {
    Promise.all([
      api("/admin/dashboard"),
      api("/admin/analytics"),
    ]).then(([dash, analytics]) => {
      if (dash.ok) setData(dash.data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: 40, color: SUB, textAlign: "center" }}>⏳ Loading chat data...</div>;

  const fmt = (n) => Number(n || 0).toLocaleString();

  return (
    <div>
      <div style={{ fontSize: 22, fontWeight: 800, color: TEXT, marginBottom: 4 }}>💬 Chats</div>
      <div style={{ fontSize: 12, color: SUB, marginBottom: 24 }}>Messages, conversations and Red Room activity</div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 20 }}>
        {[
          { label: "Total Messages", value: fmt(data?.total_messages), color: PRI },
          { label: "Messages Today", value: fmt(data?.msgs_today), color: GRN },
          { label: "Active Today", value: fmt(data?.active_today), color: GOLD },
          { label: "Active This Week", value: fmt(data?.active_week), color: "#8b5cf6" },
        ].map((s, i) => (
          <div key={i} style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 12, padding: "18px 20px" }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: SUB, textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>{s.label}</div>
            <div style={{ fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}</div>
          </div>
        ))}
      </div>

      {/* Top chatters today */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🏆 Top Chatters Today</div>
          {!data?.active_chatters?.length
            ? <div style={{ textAlign: "center", padding: "30px 0", color: SUB, fontSize: 13 }}>No chats today yet</div>
            : data.active_chatters.map((c, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderBottom: i < data.active_chatters.length - 1 ? `1px solid ${BORDER}` : "none" }}>
                <span style={{ fontSize: 12, color: SUB, width: 24, textAlign: "right", fontWeight: 700 }}>{i + 1}</span>
                <div style={{ width: 36, height: 36, borderRadius: 18, background: `linear-gradient(135deg, ${PRI}, #a23ad1)`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                  {c.user?.avatar_emoji || "👤"}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: TEXT }}>{c.user?.name || "Unknown"}</div>
                  <div style={{ fontSize: 11, color: SUB, textTransform: "capitalize" }}>{c.user?.plan || "free"}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 18, fontWeight: 800, color: "#06b6d4" }}>{c.msg_count}</div>
                  <div style={{ fontSize: 10, color: SUB }}>msgs</div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Messages per day chart */}
        <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📈 Message Volume (30 days)</div>
          {data?.msgs_today !== undefined ? (
            <>
              <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
                {[
                  { label: "Today", value: data.msgs_today, color: GRN },
                  { label: "Total", value: data.total_messages, color: PRI },
                ].map((s, i) => (
                  <div key={i} style={{ flex: 1, background: t.input, borderRadius: 10, padding: 12, textAlign: "center" }}>
                    <div style={{ fontSize: 18, fontWeight: 800, color: s.color }}>{fmt(s.value)}</div>
                    <div style={{ fontSize: 11, color: SUB, marginTop: 4 }}>{s.label}</div>
                  </div>
                ))}
              </div>
              <div style={{ fontSize: 13, color: SUB, lineHeight: 1.7 }}>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${BORDER}` }}>
                  <span>Active users today</span>
                  <span style={{ fontWeight: 700, color: TEXT }}>{fmt(data.active_today)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${BORDER}` }}>
                  <span>Active this week</span>
                  <span style={{ fontWeight: 700, color: TEXT }}>{fmt(data.active_week)}</span>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0" }}>
                  <span>Active this month</span>
                  <span style={{ fontWeight: 700, color: TEXT }}>{fmt(data.active_month)}</span>
                </div>
              </div>
            </>
          ) : <div style={{ textAlign: "center", padding: "30px 0", color: SUB }}>No data yet</div>}
        </div>
      </div>

      {/* Jilink AI chats */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px", marginBottom: 20 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>🤖 Jilink AI Usage</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
          {[
            { label: "Chats Today", value: data?.jilink_today || 0, color: "#8b5cf6" },
            { label: "Chats This Week", value: data?.jilink_week || 0, color: PRI },
            { label: "Unique Users", value: data?.jilink_users || 0, color: GRN },
          ].map((s, i) => (
            <div key={i} style={{ background: t.input, borderRadius: 12, padding: "16px 20px", textAlign: "center" }}>
              <div style={{ fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 11, color: SUB, marginTop: 6 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Top messagers all time */}
      <div style={{ background: CARD, border: `1px solid ${BORDER}`, borderRadius: 14, padding: "20px 24px" }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: TEXT, marginBottom: 16 }}>📊 Platform Chat Stats</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 }}>
          {[
            { icon: "💬", label: "DM Conversations", desc: "Private messages between users", color: PRI },
            { icon: "🔴", label: "Red Rooms", desc: "Anonymous live chat rooms", color: RED },
            { icon: "🤖", label: "AI Chats", desc: "Jilink AI conversations", color: "#8b5cf6" },
          ].map((item, i) => (
            <div key={i} style={{ background: t.input, borderRadius: 12, padding: 16, border: `1px solid ${BORDER}` }}>
              <div style={{ fontSize: 24, marginBottom: 8 }}>{item.icon}</div>
              <div style={{ fontSize: 13, fontWeight: 700, color: item.color, marginBottom: 4 }}>{item.label}</div>
              <div style={{ fontSize: 11, color: SUB }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}